import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-sublimetext',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Sublime Text icon</title><path d="M20.953.004a.397.397 0 0 0-.18.017L3.225 5.585c-.175.055-.323.214-.402.398a.42.42 0 0 0-.06.22v5.726a.42.42 0 0 0 .06.22c.079.183.227.341.402.397l7.454 2.364-7.454 2.363c-.255.08-.463.374-.463.655v5.688c0 .282.208.444.463.363l17.55-5.565c.237-.075.426-.336.452-.6.003-.022.013-.04.013-.065V12.06c0-.281-.208-.575-.463-.656L13.4 9.065l7.375-2.339c.255-.08.462-.375.462-.656V.384c0-.211-.117-.355-.283-.38z"/></svg>`,
    styles: []
})
export class SimpleIconsSublimetextComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF9800';
    @Input() className: string = 'simple-icons-sublimetext'
    constructor() {}
    ngOnInit(): void {}
}
